import styles from './LikePanel.module.css'
import notification from './../../../../image/ic_notification.svg'
import notificationRed from './../../../../image/ic_notification_red_shape.svg'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
export const LikePanel = ({currentCount, isUser}:{currentCount:number|null,isUser:boolean}) =>{
    const navigation = useNavigate();
    const keyStorage:string = "likeUserCount"
    const [isVisibleRedRound,setIsVisibleRedRound]=useState<boolean>(false)

    useEffect(()=>{
       debugger
       if(currentCount===null){
            return
       }else{
            const likeCount = localStorage.getItem(keyStorage)
            const count = likeCount===null?0:parseInt(likeCount)
            if(isUser==true){
                if(count!=currentCount){
                    localStorage.setItem(keyStorage,currentCount?currentCount.toString():"0")
                    setIsVisibleRedRound(true)
                }
            } 
        }
    },[currentCount])

    const ClickNotification = () =>{
        navigation('/notification')
    }

    return (
        <div className={styles.like_panel_container}>
            {
                isUser?<img src={isVisibleRedRound===true?notificationRed:notification} onClick={()=>{ClickNotification()}}/>
                :<img src={notification} onClick={()=>{ClickNotification()}}/>
            }
            <div style={{position:"relative"}}>
                <div style={{position:"absolute", left:"-5px", bottom:0}}>
                    {currentCount}
                </div>
            </div>
        </div>
    )
}